<template>
  <div class="">
    <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix"> 
      <el-form-item label="订单类型：" prop="fbillstatus" class="tinp" >
            <el-select v-model="OrderType" placeholder="请选择订单状态" clearable class="myselect" >
              <el-option v-for="item in fbillstatulist" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item> 
      <el-form-item label="订单编号：" class="tinp">
        <el-input v-model="vbillcode" placeholder="请输入订单编号" suffix-icon="el-icon-search" clearable ></el-input>
      </el-form-item> 
      <!-- <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div> -->
      <el-button type="primary" class="" size="small" icon="el-icon-search" @click="getlist"  v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button> 
 <!--      <el-button type="primary" v-if="pageFlag==0||OrderType==0" class="fr" size="small" icon="el-icon-printer" @click="daochu" style="margin:0 10px 10px">导出0</el-button>  -->
       <el-button type="primary" v-if="pageFlag==0||OrderType==0" class="fr" size="small" icon="el-icon-printer" @click="exportPresentSock3" style="margin:0 10px 10px">导出</el-button> 
      <el-button type="primary" v-if="pageFlag==1||OrderType==1" class="fr" size="small" icon="el-icon-printer" @click="exportPresentSock" style="margin:0 10px 10px">导出</el-button> 
    </el-form>
     <!-- <section ref="printtable"> -->
    <div class="tablebox kucun tableboxprint">
    	<!-- 0盘点 -->
      <table style="width:100%" v-if="pageFlag==0||OrderType==0">
        <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
          <th style="" v-for="head in tableHeads">{{ head.label }}</th>
          <!-- <th>操作</th> -->
        </tr>
        <tr v-for="(item,index) in tableList.productList" :key="index">
          <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px">
            <span>{{item[head.key]}}</span>
          </td> 
        </tr>
        <tr v-if="count==0">
          <td colspan="11" style="border:0;background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
        </tr>
      </table> 
      <table style="width:100%" v-else-if="pageFlag==1||OrderType==1">
        <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
          <th style="" v-for="head in tableHeads2">{{ head.label }}</th>
          <!-- <th>操作</th> -->
        </tr>
        <tr v-for="(item,index) in conditions.productList" :key="index">
          <td v-for="head in tableHeads2" style="border: 1px solid #56B8AA; height: 38px">
            <span>{{item[head.key]}}</span>
          </td> 
        </tr>
        <tr v-if="count==0">
          <td colspan="11" style="border:0;background-color: rgba(239,240,244,1);height:40px;color:#909399">暂无数据</td>
        </tr>
      </table>
    </div>
     <!-- </section> -->
     
    <!-- model end -->
    <div class="" v-show="fullscreenLoading"  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
</template>
<script> 
import { getElementsByClassName } from '../../../static/js/getDomByClassName.js'  
export default {
  name: '',
  data() {
    return {
      pageFlag:'',
      OrderType:0,
      fbillstatulist: [{
          label: '盘点单据',
          value: 0
        },
        {
          label: '货位调整单据',
          value: 1
        }

      ],
      flag:false, 
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      vbillcode:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      width: 0, //动态宽度
      page: 1,
      pageSize: 10,
      count: 0,
      conditions: {},
      position: {
        positioncode: '', //货位编码
        positionname: '', //货位名称
      },
      positionList: [],
      fullscreenLoading: false,
      userInfo: {}, 
      tableHeads: [
      	{
          label: '仓库',
          key: 'repertoryname'
        },
        {
          label: '货位',
          key: 'rackname'
        },
        {
          label: '商品编码',
          key: 'materialcode'
        },
        {
          label: '商品名称',
          key: 'materialname'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitname'
        },
        {
          label: '库存数量',
          key: 'nonhandastnum'
        },   
        {
          label: '盘点数量',
          key: 'ncountnum'
        }, 
        {
          label: '原因',
          key: 'vreason'
        }
      ], 
      tableHeads2: [
      	 
        {
          label: '调出货位',
          key: 'houtpositionname'
        }, 
        {
          label: '调入货位',
          key: 'hinpositionname'
        },
        {
          label: '商品编码',
          key: 'productCode'
        },
        {
          label: '商品名称',
          key: 'productName'
        },
        // {
        //   label: '供应商',
        //   key: 'suppliername'
        // },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitName'
        },
        {
          label: '数量',
          key: 'nnum'
        }, 
        {
          label: '备注',
          key: 'memo'
        }
      ],
      tableList: {},
      InterfacePath: ''
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.pageFlag = this.$route.query.pageFlag;
    this.OrderType = this.$route.query.pageFlag;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pageSize");
    sessionStorage.removeItem("kucunlist");
    sessionStorage.removeItem("clocationid");
    sessionStorage.removeItem("Keyword");
    sessionStorage.removeItem("count");
    //console.log("清除session");
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             //console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                //console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow =false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了';  
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },  
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    daochu(){
      var data = this.conditions.productList;
      let blob = new Blob([data], {
        type: "application/octet-stream"
      });
      let filename = "filename.xlsx";
      if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", filename);
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
      }
    },
    exportPresentSock() {
      require.ensure([], () => {
        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader = ['调出货位','调入货位','商品名称', '商品编码', '规格', '型号', '单位', '数量', '备注'];
        var filterVal = ['houtpositionname','hinpositionname','productName','productCode',  'wlspec', 'wltype', 'cunitName', 'nnum', 'memo'];
        var list = JSON.parse(JSON.stringify(this.conditions.productList));
        var data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '货位调整单');
      })
    },
    exportPresentSock3() { 
      require.ensure([], () => {
        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader2 = ['仓库', '货位', '商品名称', '商品编码', '规格', '型号', '单位','库存数量', '盘点数量', '原因'];
        var filterVal2 = ['repertoryname','rackname','materialname', 'materialcode', 'wlspec', 'wltype','cunitname','nonhandastnum', 'ncountnum','vreason'];
        var list2 = JSON.parse(JSON.stringify(this.tableList.productList));
        var data2 = this.formatJson(filterVal2, list2);
        export_json_to_excel(tHeader2, data2, '盘点单');
      })
    },
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.userInfo.storecode
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
          // this.getlist();
        }else if(res.data.status == '-1'){
            this.positionList = [];
            this.$message({
              showClose:true,
              message:'暂无数据！',
              type:'info'
            })
        } else if(res.data.status == '9'){
        	this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
        }    
      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '获取货位接口失败';
        this.butflag =false;
        this.butmsg='知道了';  
      });
    }, 
    init() {
      var users = JSON.parse(window.localStorage.getItem("userInfo"));
      if (users != null) {
        this.userInfo = users;
      }
      this.width = document.documentElement.clientWidth - 200;
      
      // this.getposition();
      // this.getlist();   
      //console.log("2"); 
    },
 
    getlist() { //获取数据
      this.fullscreenLoading = true;
      //搜索参数 
      var reqparam = { 
        vbillcode: this.vbillcode, //单号  
      };
      var methodName = '/selectInvcount';
      //console.log("this.OrderType"+this.OrderType);
      if(this.pageFlag==1||this.OrderType==1){
      		methodName = '/selectBilladjustment'
      }
      //console.log("methodName-=-==m" + methodName)
      //console.log("reqpara-=-==m" + JSON.stringify(reqparam))
      this.$http.post(this.utilpath + methodName, reqparam, { emulateJSON: true})
        // this.$http.post("/ktnapi/selectPresentSock",reqparam,{emulateJSON:true})
        // this.$http.post(this.InterfacePath+"/selectPresentSock",reqparam,{emulateJSON:true}) 
        .then((res) => {
          if(res.data.status=='0'){ 
              this.fullscreenLoading = false; 
              if(this.pageFlag==0||this.OrderType==0){

              this.tableList = res.data.resultList[0];  
              }else{
              this.conditions = res.data.resultList[0];  

              }
              this.count = res.data.countNum;

              //console.log("打印返回值tableList：" + JSON.stringify(this.tableList));
              //console.log("打印返回值conditions：" + JSON.stringify(this.conditions));
              //console.log("打印数据长度：" + this.count); 
          }else if(res.data.status=='-1'){
              this.fullscreenLoading = false; 
              this.tableList =[];
              this.count =0;
              this.$message({
                  showClose:true,
                  message:'暂无数据！',
                  type:'info'
              })
          } else if(res.data.status == '9'){
          	this.fullscreenLoading = false; 
                this.$router.push({path:'/ui/login',query:{msg:9}});
          } else{
              this.fullscreenLoading = false;
              this.modelFlag = true;
              this.msgShow = true;
              this.methodName = 'message';
              this.msg = res.data.message;
              this.butflag =false;
              this.butmsg='知道了'; 
          }
        }, (err) => {
          this.fullscreenLoading = false;
          this.msgShow =false;
            this.modelFlag = true;
            this.methodName = 'message';
            this.msg = '连接获取现存量接口失败'+err;
            this.butflag =false;
            this.butmsg='知道了';
        });
      sessionStorage.setItem("clocationid", this.conditions.input1);
      sessionStorage.setItem("Keyword", this.conditions.input2);
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pageSize", this.pageSize);
      sessionStorage.setItem("count", this.count);
    },
    onParamChange(attr, val) { //搜索变更事件 
    	//console.log("vbillcode:单引号"+(this.vbillcode=='')+"vbillcode:null"+(this.vbillcode==null)+"vbillcode:双引号"+(this.vbillcode==null));
    	if((this.vbillcode!='')){ 
      			this.getlist(); 
    	}
    }, 
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stock/exportlist.vue